import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, CircularProgress, Typography, Button, Paper } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";

const PublicTicketView = () => {
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);

  const backendUrl = process.env.REACT_APP_API_URL || "https://srv1866478.hstgr.cloud";

  useEffect(() => {
    let currentBlobUrl = null;

    const cargarTicket = async () => {
      if (!token) {
        setError("Token no válido");
        setLoading(false);
        return;
      }
      try {
        const endpoint = `${backendUrl.replace(/\/$/, "")}/consultaweb/ticket/${token}`;
        const res = await fetch(endpoint);

        if (!res.ok) {
          if (res.status === 404) {
            setError("El ticket solicitado ya no se encuentra disponible.");
          } else if (res.status === 403) {
            setError("El enlace de este ticket ha expirado por seguridad.");
          } else {
            setError("No se pudo cargar el ticket.");
          }
          setLoading(false);
          return;
        }

        const blob = await res.blob();
        currentBlobUrl = URL.createObjectURL(blob);
        setPdfBlobUrl(currentBlobUrl);
      } catch (err) {
        console.error("Error al obtener ticket:", err);
        setError("Error al comunicar con el servidor.");
      } finally {
        setLoading(false);
      }
    };

    cargarTicket();

    return () => {
      if (currentBlobUrl) {
        URL.revokeObjectURL(currentBlobUrl);
      }
    };
  }, [token, backendUrl]);

  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#f4f7f9",
      }}
    >
      {loading && (
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress sx={{ color: "#18234f", mb: 2 }} />
          <Typography variant="body1" sx={{ color: "#555" }}>
            Cargando ticket de compra...
          </Typography>
        </Box>
      )}

      {!loading && error && (
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: 2,
          }}
        >
          <Paper
            elevation={4}
            sx={{
              p: 4,
              borderRadius: 3,
              textAlign: "center",
              maxWidth: 420,
              width: "100%",
              borderTop: "6px solid #d32f2f",
            }}
          >
            <Typography variant="h6" sx={{ color: "#18234f", fontWeight: "bold", mb: 2 }}>
              LABORATORIOS GARCÍA
            </Typography>
            <Typography variant="body1" color="error" sx={{ mb: 2 }}>
              {error}
            </Typography>
          </Paper>
        </Box>
      )}

      {!loading && !error && pdfBlobUrl && (
        <Box sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column" }}>
          <Box
            sx={{
              backgroundColor: "#18234f",
              color: "#fff",
              px: 3,
              py: 1.5,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Ticket de Compra - Laboratorios García
            </Typography>
            <Button
              variant="contained"
              size="small"
              startIcon={<DownloadIcon />}
              href={pdfBlobUrl}
              download={`Ticket_${token}.pdf`}
              sx={{ backgroundColor: "#25D366", "&:hover": { backgroundColor: "#1ebd59" } }}
            >
              Descargar PDF
            </Button>
          </Box>
          <iframe
            src={pdfBlobUrl}
            title="Ticket PDF"
            style={{ width: "100%", height: "100%", border: "none" }}
          />
        </Box>
      )}
    </Box>
  );
};

export default PublicTicketView;
